module.exports = __webpack_public_path__ + "static/2ndYear-b1029a0bb085c24cbb6cbf94f33ad9e2.png";